<template>
  <div class="md:bg-dark-foreground rounded-lg">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "VPanel"
}
</script>

<style scoped>

</style>